// selectors.js
import { createSelector } from 'reselect';


const getCuttingReturnMemo = (state) => state.StitchDatalist.reMemo;
export const selectCuttingReturnMemo = createSelector(
  [getCuttingReturnMemo],
  (reMemo) => reMemo || { data: [] }
);

const getFusionMemostitch = (state) => state.StitchDatalist.fmemost;
export const selectFusionMemoStitch = createSelector(
  [getFusionMemostitch],
  (reMemo) => reMemo || { data: [] }
);

const getStitchEmplist = (state) => state.StitchDatalist.emplist;
export const selectStitchEmplist = createSelector(
  [getStitchEmplist],
  (reMemo) => reMemo || { data: [] }
);

const getStitchToPackEmp = (state) => state.StitchDatalist.stpackEmp;
export const selectStitchToPackEmplist = createSelector(
  [getStitchToPackEmp],
  (reMemo) => reMemo || { data: [] }
);

const getStitchMemoNo = (state) => state.StitchDatalist.stMemo;
export const selectStitchingMemoNo = createSelector(
  [getStitchMemoNo],
  (stMemo) => stMemo || { data: [] }
);

const getStitchRegister = (state) => state.StitchDatalist.stlist;
export const selectStitchReg = createSelector(
  [getStitchRegister],
  (stlist) => stlist || { data: [], Info: [], count_stId: [] }
);

const getStitchContractorReg = (state) => state.StitchDatalist.contlist;
export const selectStitchContraRegister = createSelector(
  [getStitchContractorReg],
  (stlist) => stlist || { data: [], Info: [], count_stId: [] }
);

const getStitchReturn = (state) => state.StitchDatalist.stReturn;
export const selectStitchReturn = createSelector(
  [getStitchReturn],
  (stReturn) => stReturn || { data: [], Info: [] }
);

const getStitchContratorReturn = (state) => state.StitchDatalist.contReturn;
export const selectStitchContraReturn = createSelector(
  [getStitchContratorReturn],
  (stReturn) => stReturn || { data: [], Info: [] }
);

const getStitchReturnGrpStid = (state) => state.StitchDatalist.stRGrp;
export const selectStitchReGrpStId = createSelector(
  [getStitchReturnGrpStid],
  (stReturn) => stReturn || { data: [], data2: [] }
);

const getStitchReturnGrpStid2 = (state) => state.StitchDatalist.stRGrp2;
export const selectStitchReGrpStId2 = createSelector(
  [getStitchReturnGrpStid2],
  (stReturn2) => stReturn2 || { data: [], data2: [] }
);

const getStitchContReGrp = (state) => state.StitchDatalist.contReGrp;
export const selectStitchContReGrp = createSelector(
  [getStitchContReGrp],
  (stReturn) => stReturn || { data: [], data2: [], Info: [] }
);

const getKajeMemo = (state) => state.KajeDatalist.kjMemo;
export const selectKajeMemoNo = createSelector(
  [getKajeMemo],
  (kjMemo) => kjMemo || { data: [] }
);

const getKajeEmplist = (state) => state.KajeDatalist.emplist;
export const selectKajeEmplist = createSelector(
  [getKajeEmplist],
  (kjlist) => kjlist || { data: [] }
);

const getStitchReturnMemo = (state) => state.KajeDatalist.reMemo;
export const selectStitchReturnMemo = createSelector(
  [getStitchReturnMemo],
  (reMemo) => reMemo || { data: [], kstMemo: [], pstMemo: [] }
);

const getKajeReg = (state) => state.KajeDatalist.kjlist;
export const selectKajeRegister = createSelector(
  [getKajeReg],
  (kjlist) => kjlist || { data: [], Info: [] }
);

const getKajeRegReturn = (state) => state.KajeDatalist.kjreturn;
export const selectKajeReturnReg = createSelector(
  [getKajeRegReturn],
  (kjreturn) => kjreturn || { data: [] }
);

const getPressMemo = (state) => state.PressDatalist.prMemo;
export const selectPressMemoNo = createSelector(
  [getPressMemo],
  (prMemo) => prMemo || { data: [] }
);

const getStitchReturnOption = (state) => state.PressDatalist.sreMemo;
export const selectStReturnOptions = createSelector(
  [getStitchReturnOption],
  (sreMemo) => sreMemo || { data: [] }
);

const getKajeOptions = (state) => state.PressDatalist.kreMemo;
export const selectKajeOptions = createSelector(
  [getKajeOptions],
  (kreMemo) => kreMemo || { data: [] }
);

const getPressEmplist = (state) => state.PressDatalist.emplist;
export const selectPressEmplist = createSelector(
  [getPressEmplist],
  (emplist) => emplist || { data: [] }
);

const getPressRegProduction = (state) => state.PressDatalist.prlist;
export const selectPressRegPro = createSelector(
  [getPressRegProduction],
  (emplist) => emplist || { data: [] }
);

const getStockMemo = (state) => state.StockDatalist.stkMemo;
export const selectStockMemoNo = createSelector(
  [getStockMemo],
  (stkMemo) => stkMemo || { data: [] }
);

const getStkBarcode = (state) => state.StockDatalist.stkbar;
export const selectStkBarcode = createSelector(
  [getStkBarcode],
  (stkBar) => stkBar || { data: [] }
);

const getContCuttingReMemo = (state) => state.StockDatalist.contCutRetmemo;
export const selectContCuttingReMemo = createSelector(
  [getContCuttingReMemo],
  (contCutRetmemo) => contCutRetmemo || { data: [] }
);

const getStkProductionReg = (state) => state.StockDatalist.stkReg;
export const selectStkProductionReg = createSelector(
  [getStkProductionReg],
  (stkReg) => stkReg || { data: [] }
);


const getStkInwMemos = (state) => state.StockDatalist.allMemos;
export const selectStkInwMemos = createSelector(
  [getStkInwMemos],
  (stkMemo) => stkMemo || { stitchMemo: [] }
);

const getManualStkReg = (state) => state.StockDatalist.manualStk;
export const selectManualStkReg = createSelector(
  [getManualStkReg],
  (manualStk) => manualStk || { data: [] }
);